module.exports = __webpack_public_path__ + "img/font.a0bb1be9.svg";